import React, { useState } from 'react';
import AccountPage from '../components/AccountPage';
import PassportServiceCard from '../components/PassportServiceCard';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { services } from '../components/Services';
import { useSelector } from 'react-redux';
import Button from '../../../components/Button';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import * as track from '../../../lib/track';
import IntroDialogue from '../components/IntroDialogue';
import { AuthAPI } from '../../../api';
import { AuthStore } from '../../../store';

const useStyles = makeStyles(theme => ({
  section: {
    padding: '1rem 0 2rem 0',
  },
  cardList: {
    padding: '1rem 0',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const HomePage = () => {
  const classes = useStyles();
  const history = useHistory();
  const profile = useSelector(state => state.auth.profile);
  const displayedServices = services.filter(s => s.name !== 'Home');
  const name = profile.first_name === null ? profile.username : profile.first_name;
  const welcomeMessage = `Welcome back ${name}.`;
  const showIntro = 'show_intro' in profile && profile.show_intro ? true : false;
  const [introOpen, setIntroOpen] = useState(showIntro);

  const closeIntro = async () => {
    try {
      await AuthAPI.updateProfile({show_intro: false});
      await AuthStore.refreshProfile();
    } finally {
      setIntroOpen(false);
    }
  };

  const clickFindProvider = () => {
    track.sendEvent('user account find provider button', 'click', {});
    history.push('/requestmatch');
  };

  return (
    <AccountPage title={welcomeMessage}>
      <IntroDialogue open={introOpen} onClose={closeIntro} />
      <div className={classes.section}>
        <Typography variant="body2" gutterBottom>We&apos;re building a suite of tools to help you manage your NDIS journey. If there&apos;s something that&apos;s important to you, please let us know via our <Link to="/profile/feedback" className={classes.link}>feedback</Link> form.</Typography>
        <Button label="Help me find a provider" color="secondary" pointer="right" onClick={clickFindProvider} style={{marginTop: '2rem', color: 'white'}}/>
      </div>
      <div className={classes.section}>
        <Typography variant="h3" color="primary" gutterBottom>Services</Typography>
        <div className={classes.cardList}>
          {displayedServices.map(service => <PassportServiceCard key={service.name} service={service} />)}
        </div>
      </div>
    </AccountPage>
  );
};

export default HomePage;
